module.exports = new __parcel__URL__("shop_fur_69_chip_image.5c75e744.png").toString();